import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { ModelGeoCampaign } from "@models/ModelGeoCampaign";
import groupAndSpreadMarkers from "@/utils/groupAndSpreadMarkers";
import getSpreadDistance from "@/utils/getSpreadDistance.ts";

interface UseMarkerManagementProps {
  fetchData: any;
  pathname: string;
  zoomLevel: number;
  infoWindow: any;
}

export const useMarkerManagement = ({
  fetchData,
  pathname,
  zoomLevel,
  infoWindow,
}: UseMarkerManagementProps) => {
  const { id } = useParams();
  const [clusterMarkers, setClusterMarkers] = useState<ModelGeoCampaign[]>([]);
  const [detailMarkers, setDetailMarkers] = useState<ModelGeoCampaign[]>([]);

  useEffect(() => {
    if (!fetchData?.data?.campaigns) return;

    // Detail page specific logic
    if (pathname.startsWith("/detailPage") && id) {
      const campaignById = fetchData.data.campaigns.find(
        (item: ModelGeoCampaign) => item.id === Number(id)
      );
      if (campaignById) {
        if (
          detailMarkers.length !== 1 ||
          detailMarkers[0].id !== campaignById.id
        ) {
          setDetailMarkers([campaignById]);
        }
      }
    }

    // Map campaign page logic
    if (pathname.startsWith("/map-campaign")) {
      if (zoomLevel < 12) {
        const filteredClusters = fetchData.data.campaigns.filter(
          (el: ModelGeoCampaign) => el.total_campaigns !== 0
        );

        if (
          clusterMarkers.length !== filteredClusters.length ||
          clusterMarkers.some((c, i) => c.id !== filteredClusters[i]?.id)
        ) {
          const spread = getSpreadDistance(zoomLevel);
          setClusterMarkers(groupAndSpreadMarkers(filteredClusters, spread, 1000));
          setDetailMarkers([]);
          if (infoWindow) infoWindow.close();
        }
      } else {
        const spread = getSpreadDistance(zoomLevel);
        setDetailMarkers(groupAndSpreadMarkers(fetchData.data.campaigns, spread, 20));
        setClusterMarkers([]);
      }
    }
  }, [fetchData, zoomLevel, pathname, id, infoWindow]);

  return { clusterMarkers, detailMarkers };
};
